import { render } from "./NoticiasDestacadasComponent.vue?vue&type=template&id=12360d9b"
import script from "./NoticiasDestacadasComponent.vue?vue&type=script&lang=js"
export * from "./NoticiasDestacadasComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__